import script from "./Jumbo.vue?vue&type=script&setup=true&lang=js"
export * from "./Jumbo.vue?vue&type=script&setup=true&lang=js"

import "./Jumbo.vue?vue&type=style&index=0&id=63bcb12e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63bcb12e"]])

export default __exports__